import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AwsSchedulerService } from '../../modules/operational-reports/services/aws-scheduler.service';

@Component({
  selector: 'app-popup-confirmation',
  templateUrl: './popup-confirmation.component.html',
  styleUrls: ['./popup-confirmation.component.scss']
})
export class PopupConfirmationComponent {

  originalOrder = (): number => 0; // Disable sorting
  formattedDetails: { key: string, value: any }[] = [];
  reason: string = '';
  isReason: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PopupConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private awsService:AwsSchedulerService
  ) {
    console.log("data-17",data);
    const rawDetails = this.data.details;
    this.isReason = this.data.isReason || false;
    this.formattedDetails = Object.entries(rawDetails).map(([key, value]) => ({
    key,
    value
  }));
  }

  closeDialog(result: boolean): void {
    if(result == true) this.awsService.scheduleStopReason = this.reason;
    this.dialogRef.close(result);
  }
}
